module.exports = __webpack_public_path__ + "static/flume-logo-0a7347f7ef1e3b759cf7efcbca2078ce.png";